<template>
  <div>
    <div v-if="!validSuscription">
      <b-alert
        variant="warning"
        show
      >
        <div class="alert-body">
          <feather-icon
            icon="InfoIcon"
            class="mr-50"
          />
          No se puede realizar la suscripción, el contrato ya tiene
          una suscripción en curso. Si desea agregar una nueva
          tarjeta, elimine la actual.
          <br>
          <br>
          <b-link :to="{ path: '/perfil/suscription' }">
            Ver suscripción
          </b-link>
        </div>
      </b-alert>
    </div>
    <div v-else>
      <b-overlay
        :show="show"
        rounded="sm"
      >
        <template #overlay>
          <div class="text-center">
            <div class="h2 mb-0">
              <b-icon-watch
                font-scale="3"
                animation="cylon"
              />
            </div>
            <h2 class="text-dark">
              Procesando ....
            </h2>
          </div>
        </template>
        <b-card>
          <b-row>
            <b-col md="12">
              <ul>
                <li>
                  <b>Nombres:</b>
                  {{ contract.apenom }}
                </li>
                <li>
                  <b>Contrato:</b>
                  {{ contract.codigo }}
                </li>
                <li>
                  <b>Identificación:</b>
                  {{ contract.ruc }}
                </li>
                <li>
                  <b>Email:</b>
                  {{ contract.email }}
                </li>
                <li>
                  <b>Tarifa:</b>
                  {{ contract.tarifa }}
                </li>
              </ul>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <p class="text-justify">
                Estimado, {{ contract.apenom }}
                al continuar acepta los
                <b-link
                  :href="termsUrl"
                  target="_blank"
                >
                  Terminos y Condiciones
                </b-link>
                y
                <b-link
                  :href="privacyUrl"
                  target="_blank"
                >
                  Proteccion de Datos Personales
                </b-link>
                de la plataforma.
                <br>
                Puede obtener más información sobre el uso de la
                Plataforma y Nuvei consultando la guia de
                <b-link
                  :href="faqUrl"
                  target="_blank"
                >
                  Preguntas Frecuentes
                </b-link>
              </p>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <validation-observer ref="ttForm">
                <b-form>
                  <b-form-group
                    label="* Seleccione Dia de Débito"
                    label-for="debit-day"
                  >
                    <validation-provider
                      #default="validationContext"
                      name="Dia Debito"
                      rules="required"
                    >
                      <v-select
                        v-model="debit_day"
                        :dir="
                          $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr'
                        "
                        :options="listDays"
                        label="text"
                        :clearable="false"
                        input-id="debit-day"
                        :reduce="(val) => val.value"
                      />
                      <small class="text-danger">
                        {{
                          validationContext.errors[0]
                        }}
                      </small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label="Aceptar"
                    label-for="tt-accept"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Aceptar"
                      rules="required"
                    >
                      <b-form-checkbox
                        v-model="accept"
                        class="mr-0 mt-1"
                        name="tt-accept"
                        switch
                        inline
                      />

                      <small class="text-danger">
                        {{ errors[0] }}
                      </small>
                    </validation-provider>
                  </b-form-group>

                  <!-- Formulario de tokenización -->
                  <div id="payment_example_div">
                    <div id="tokenize_example" />
                    <div id="response" />

                    <button
                      id="tokenize_btn"
                      class="tok_btn"
                    >
                      Guardar tarjeta
                    </button>
                    <button
                      id="retry_btn"
                      class="tok_btn"
                      style="display: none"
                    >
                      Guardar nueva tarjeta
                    </button>

                    <!-- <b-button
                                            id='tokenize_btn'
                                            variant="success"
                                            block
                                            size="lg"
                                            :disabled="!accept"
                                            class="mt-1"
                                        >
                                            Guardar tarjeta
                                        </b-button> -->
                  </div>

                  <b-form-group class="mt-3">
                    <!-- <b-img
                                            fluid
                                            center
                                            src="https://static.placetopay.com/placetopay-logo.svg"
                                        /> -->
                    <b-img
                      fluid
                      center
                      class="mt-1"
                      src="https://clientes-tt.s3.amazonaws.com/rapinet/portal_clientes_pasarela/franquicias_tarjetas.jpeg"
                    />
                  </b-form-group>
                </b-form>
              </validation-observer>
            </b-col>
          </b-row>
        </b-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import paymentMixin from '@/mixins/paymentMixin'
import formValidation from '@core/comp-functions/forms/form-validation'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required } from '@validations'
import {
    BAlert,
    BButton,
    BCard,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BIconWatch,
    BImg,
    BLink,
    BOverlay,
    BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
    components: {
        BOverlay,
        BIconWatch,
        BCard,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormCheckbox,
        BButton,
        BImg,
        BLink,
        BAlert,
        vSelect,
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [paymentMixin],
    props: {
        contract: {
            type: Object,
            default: () => {},
            required: true,
        },
    },
    setup() {
        const termsUrl = process.env.VUE_APP_TERMS_URL
        const privacyUrl = process.env.VUE_APP_PRIVACY_URL
        const faqUrl = process.env.VUE_APP_FAQ_URL
        const envMode = process.env.VUE_APP_NUVEI_ENV_MODE

        const { getValidationState } = formValidation(() => {})

        return {
            termsUrl,
            privacyUrl,
            faqUrl,
            envMode,
            getValidationState,
            required,
        }
    },
    data() {
        return {
            show: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            accept: false,
            listDays: [],
            debit_day: 0,
            pg_sdk: null,
            tokenizeData: null,
            validSuscription: true,
        }
    },
    created() {
        this.listDays.push({ value: 5, text: '5 de cada Mes' })

        this.fetchValidSuscription()
    },
    mounted() {
        this.initializePaymentGateway()
    },
    methods: {
        fetchValidSuscription() {
            this.$http
                .get('/nuvei/suscription/valid', {
                    params: {
                        idcontrato: this.contract.idcontrato,
                    },
                })
                .then((response) => {
                    this.validSuscription = response.data.valid
                })
        },

        async initializePaymentGateway() {
            await this.loadExternalScripts()

            const environment = this.envMode
            const application_code = process.env.VUE_APP_NUVEI_APP_CODE
            const application_key = process.env.VUE_APP_NUVEI_APP_KEY

            this.pg_sdk = new PaymentGateway(
                environment,
                application_code,
                application_key
            )
            this.setupTokenization()
        },

        setupTokenization() {
            const submitButton = document.querySelector('#tokenize_btn')
            const retryButton = document.querySelector('#retry_btn')
            const submitInitialText = submitButton.textContent

            this.tokenizeData = {
                locale: 'es',
                user: {
                    id: String(this.contract.idcontrato),
                    email: this.contract.email,
                },
                configuration: {
                    default_country: 'ECU',
                },
            }

            const notCompletedFormCallback = (message) => {
                document.getElementById(
                    'response'
                ).innerHTML = `Formulario incompleto: ${message}, Por favor complete los datos requeridos`
                submitButton.innerText = submitInitialText
                submitButton.removeAttribute('disabled')
            }

            const responseCallback = (response) => {
                if (response.card && response.card.status === 'valid') {
                    document.getElementById('response').innerHTML =
                        '¡Tarjeta guardada exitosamente!'
                } else {
                    document.getElementById('response').innerHTML =
                        'Error al guardar la tarjeta. Por favor, intente nuevamente.'
                }

                this.sendCardData(response.card)

                retryButton.style.display = 'block'
                submitButton.style.display = 'none'
            }

            this.pg_sdk.generate_tokenize(
                this.tokenizeData,
                '#tokenize_example',
                responseCallback,
                notCompletedFormCallback
            )

            submitButton.addEventListener('click', (event) => {
                document.getElementById('response').innerHTML = ''
                submitButton.innerText = 'Procesando tarjeta...'
                submitButton.setAttribute('disabled', 'disabled')
                this.pg_sdk.tokenize()
                event.preventDefault()
            })

            retryButton.addEventListener('click', (event) => {
                submitButton.innerText = submitInitialText
                submitButton.removeAttribute('disabled')
                retryButton.style.display = 'none'
                submitButton.style.display = 'block'
                this.pg_sdk.generate_tokenize(
                    this.tokenizeData,
                    '#tokenize_example',
                    responseCallback,
                    notCompletedFormCallback
                )
            })
        },

        sendCardData(response) {
            this.$http
                .post('/nuvei/suscription', {
                    idcontrato: this.contract.idcontrato,
                    idusuario: this.userData.id,
                    dia: this.debit_day,
                    response: response,
                })
                .then(() => {
                    this.$router.push('perfil/suscription')
                })
                .catch((error) => {
                    this.$swal({
                        title: 'Error!',
                        text: 'No se pudo guardar la tarjeta. Por favor, intente nuevamente.',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        savep2p() {
            if (!this.accept) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Debe Aceptar los Terminos y Condiciones',
                        variant: 'danger',
                        icon: 'XIcon',
                    },
                })
                return
            }

            if (!this.debit_day) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Debe seleccionar el día para debito',
                        variant: 'danger',
                        icon: 'XIcon',
                    },
                })
                return
            }

            this.show = true

            this.$http
                .post('p2p-suscription', {
                    idcontrato: this.contract.idcontrato,
                    idusuario: this.userData.id,
                    dia: this.debit_day,
                })
                .then((response) => {
                    this.show = false
                    const message = response.data.message
                    const process_url = response.data.process_url

                    window.open(process_url, '_blank')

                    this.$swal({
                        title: 'Éxito',
                        text: message,
                        icon: 'success',
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch((error) => {
                    this.show = false
                    this.$swal({
                        title: 'Error',
                        text: error.response.data.error,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },
    },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#payment_example_div {
    margin: 10 auto;
    display: block;
    justify-content: center;
    align-items: center;
}

#payment_example_div > * {
    margin: 10 auto;
}

.tok_btn:hover {
    cursor: pointer;
}

.tok_btn:disabled,
#tok_btn[disabled] {
    opacity: 0.65;
    cursor: not-allowed;
}

.tok_btn {
    background: linear-gradient(
        to bottom,
        rgba(140, 197, 65, 1) 0%,
        rgba(20, 167, 81, 1) 100%
    );
    color: #fff;
    width: 80%;
    border: 1px solid rgba(46, 86, 153, 0.0980392);
    border-bottom-color: rgba(46, 86, 153, 0.4);
    border-top: 0;
    border-radius: 4px;
    font-size: 17px;
    text-shadow: rgba(46, 86, 153, 0.298039) 0px -1px 0px;
    line-height: 34px;
    -webkit-font-smoothing: antialiased;
    font-weight: bold;
    display: block;
    align-items: center;
    margin: 0 auto;
    margin-top: 10px;
}

#retry_btn {
    display: none;
}
</style>
